import React from "react";

export default function Section2() {
  return (
    <div>
      <section className="second-hightlight-wrapper">
        <div className="container">
          <div className="new-alert1">New</div>

          <div className="title-wraper bold black">iPhone 14</div>

          <div className="description-wrapper bold black">Big and bigger.</div>

          <div className="links-wrapper">
            <ul>
              <li>
                <a href="">Learn more</a>
              </li>
              <li>
                <a href="">Buy</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
